import request from '@/utils/request'

const chechangParkingSpace = {
  communitySelect(query) {
    return request({
      url: '/chechang/parking-space/communitySelect',
      method: 'get',
      params: query
    })
  },
  list(query) {
    return request({
      url: '/chechang/parking-space/list',
      method: 'get',
      params: query
    })
  },
  detail(query) {
    return request({
      url: '/chechang/parking-space/detail',
      method: 'get',
      params: query
    })
  },
  syncParkingFee(data) {
    return request({
      url: '/chechang/parking-space/syncParkingFee',
      method: 'post',
      data
    })
  },
  sync(data) {
    return request({
      url: '/chechang/parking-space/sync',
      method: 'post',
      data
    })
  },
  syncProgress(query) {
    return request({
      url: '/chechang/parking-space/sync/progress',
      method: 'get',
      params: query
    })
  },
  syncHistory(query) {
    return request({
      url: '/chechang/parking-space/sync/history',
      method: 'get',
      params: query
    })
  },
  rentSave(data) {
    return request({
      url: '/chechang/parking-space/rent/save',
      method: 'post',
      data
    })
  },
  parentSave(data) {
    return request({
      url: '/chechang/parking-space/parent/save',
      method: 'post',
      data
    })
  }
}

export default chechangParkingSpace
